import { render, staticRenderFns } from "./ListStandoutDocuments.vue?vue&type=template&id=26ee9f38&scoped=true"
import script from "./ListStandoutDocuments.vue?vue&type=script&lang=js"
export * from "./ListStandoutDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ee9f38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ee9f38')) {
      api.createRecord('26ee9f38', component.options)
    } else {
      api.reload('26ee9f38', component.options)
    }
    module.hot.accept("./ListStandoutDocuments.vue?vue&type=template&id=26ee9f38&scoped=true", function () {
      api.rerender('26ee9f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Documents/Conferences/ListStandoutDocuments.vue"
export default component.exports